// GLOBAL VARIABLES
var tetloose = tetloose || {},
    $window = $(window),
    $document = $(document),
    $html = $('html'),
    $body = $('body'),
    $mastHead = $('[rel=js-masthead]'),
    $windowWidth = $window.width(),
    $smallMq = '465',
    $mediumMq = '753',
    $largeMq = '945',
    $xlargeMq = '1009';
